import type { GetTokenSilentlyOptions } from '@auth0/auth0-react'

export const ANALYTICS_TAB = 'analytics'

// Second Auth0 token, audience-scoped to analytics-mcp (distinct from the
// dashboard-api-audience token every request already carries via apiClient's
// interceptor) — Mastra forwards it as-is to analytics-public, which validates
// it and reads the merchant's own group from it. Only the analytics tab needs it.
export async function getAnalyticsMcpAccessToken(
  getAccessTokenSilently: (options: GetTokenSilentlyOptions) => Promise<string>
): Promise<string | undefined> {
  const audience = import.meta.env.VITE_ANALYTICS_MCP_AUDIENCE
  if (!audience) return undefined
  return getAccessTokenSilently({ authorizationParams: { audience } })
}
